import { Configuration } from './src'
import Env from '../configs/env'

export * from './src/api'
export * from './src/configuration'

export const apiConf = async (authStoreOrAccessToken = null) => {
  const config = new Configuration()
  // SSR(サーバー側)ではコンテナ間通信のホスト名を使用
  const isServer = typeof window === 'undefined'
  if (isServer) {
    console.log('isServer', isServer)
  }
  config.basePath = Env.API_END_POINT
  try {
    if (authStoreOrAccessToken) {
      let accessToken
      if (typeof authStoreOrAccessToken.getAccessToken === 'function') {
        accessToken = await authStoreOrAccessToken.getAccessToken()
      } else {
        accessToken = authStoreOrAccessToken
      }
      config.apiKey = `Bearer ${accessToken}`
    }
  } catch (err) {
    console.log(err)
  }
  return config
}
